import React, { useCallback, useState } from "react";
import FormItem from "../../../components/UI/FormItem";
import { Spin } from "antd";
import { useSelector } from "react-redux";

const QuestionList = ({
  formFields,
  setFormFields,
  fieldError,
  form,
  setFieldError,
}) => {
  const questions = useSelector(
    (state) => state.preAssessment?.questionData?.section?.questions
  );
  const [visibleQnIds, setVisibleQnIds] = useState([]);

  const handleOnChange = (value) => {
    const { question_id: qnId, opted_answer_id: answerId } = value;
    const updatedFields = formFields.map((formfield) =>
      formfield.question_id === qnId ? { ...value } : formfield
    );
    if (
      //check if the value is a new entry
      !updatedFields.some((formfield) => formfield.question_id === qnId)
    ) {
      updatedFields.push(value);
    }
    setFormFields(updatedFields);
  };

  const formatOptions = useCallback((options, isGrouped) => {
    if (isGrouped) {
      return options;
    } else {
      const formattedOptions =
        options?.map((opn) => ({
          value: opn.id,
          name: opn.option,
        })) || [];
      return formattedOptions;
    }
  }, []);

  return (
    <div className="questions-container">
      {questions && questions.length > 0 ? (
        questions.map((qn) => {
          if (
            qn?.dependant_question_id &&
            visibleQnIds[qn?.dependant_question_id] !== qn?.dependant_option_id
          ) {
            return null;
          }
          return (
            <FormItem
              key={qn?.id}
              inputType={qn?.component?.type}
              className={`preassessment-field ${
                fieldError.includes(qn?.id) ? "error" : ""
              }`}
              name={qn?.id}
              rules={[
                {
                  required: qn?.required,
                  message:
                    qn?.required_text || "Please fill the field to proceed!",
                },
              ]}
              placeholderText={qn?.question || qn?.placeholder}
              options={formatOptions(
                qn?.options,
                qn?.component?.grouped_choices
              )}
              answer={qn?.answer || qn?.answers}
              multi_resp={qn?.component?.multi_resp}
              showSearch={qn?.component?.search}
              grouped_choices={qn?.component?.grouped_choices}
              question={qn?.question}
              options_link={qn?.options_link}
              onChange={handleOnChange}
              qnId={qn?.id}
              form={form}
              selection_placeholder={qn?.selection_placeholder}
              unit={qn?.unit}
              setError={{ fieldError, setFieldError }}
              choice_has_val={qn?.component?.choice_has_val}
              required={qn?.required}
              other_placeholder={qn?.other_option_placeholder}
              choice_value_placeholder={qn?.choice_value_placeholder}
              IsClearEnabledDisabled={true}
              setVisibleQnIds={
                qn?.has_linked_question ? setVisibleQnIds : () => {}
              }
            />
          );
        })
      ) : (
        <Spin size={30} className="preassessment-loader" />
      )}
    </div>
  );
};

export default QuestionList;
